module.exports = __webpack_public_path__ + "img/delete.473f9255.svg";